// Shared DOM accessors for the contract create flow.

import type { OfferGroupsConfig } from './offer-groups';

export type OfferGroupElements = Pick<OfferGroupsConfig,
    | 'accommodationSelect' | 'transportSelect' | 'insuranceSelect'
    | 'accommodationSearchBox' | 'transportSearchBox' | 'insuranceSearchBox'
    | 'accommodationPricesContent' | 'transportPricesContent' | 'insurancePricesContent'
    | 'accommodationDetailsPanel' | 'transportDetailsPanel' | 'insuranceDetailsPanel'
    | 'transportSection' | 'insuranceSection' | 'transportFilterInfo'>;

export function getAgencyId(form: HTMLFormElement): string {
    const el = document.getElementById('AgencyId') as HTMLElement | null;
    if (el) return (el as HTMLInputElement).value;
    return document.querySelector<HTMLInputElement>('input[name="AgencyId"]')?.value
        || form.dataset.agencyId
        || '0';
}

export function getAgencyName(): string {
    const el = document.getElementById('AgencyId');
    if (el instanceof HTMLSelectElement) {
        return el.selectedOptions[0]?.textContent?.trim() || '';
    }
    return document.querySelector<HTMLInputElement>('input[name="AgencyId"]')
        ?.getAttribute('data-agency-name') || '';
}

export function getOfferGroupElements(
    accommodationSelect: HTMLSelectElement,
    transportSelect: HTMLSelectElement,
    insuranceSelect: HTMLSelectElement,
): OfferGroupElements {
    return {
        accommodationSelect,
        transportSelect,
        insuranceSelect,
        accommodationSearchBox:     document.getElementById('accommodationSearchBox') as HTMLInputElement,
        transportSearchBox:         document.getElementById('transportSearchBox') as HTMLInputElement,
        insuranceSearchBox:         document.getElementById('insuranceSearchBox') as HTMLInputElement,
        accommodationPricesContent: document.getElementById('accommodationPricesContent') as HTMLElement,
        transportPricesContent:     document.getElementById('transportPricesContent') as HTMLElement,
        insurancePricesContent:     document.getElementById('insurancePricesContent') as HTMLElement,
        accommodationDetailsPanel:  document.getElementById('accommodationDetailsPanel') as HTMLElement,
        transportDetailsPanel:      document.getElementById('transportDetailsPanel') as HTMLElement,
        insuranceDetailsPanel:      document.getElementById('insuranceDetailsPanel') as HTMLElement,
        transportSection:           document.getElementById('transportSection') as HTMLElement,
        insuranceSection:           document.getElementById('insuranceSection') as HTMLElement,
        transportFilterInfo:        document.getElementById('transportFilterInfo') as HTMLElement,
    };
}
